module.exports = __webpack_public_path__ + "static/media/header.ffcc99c4.jpg";